$(document).ready(function () {
    $('[data-scrollto]').on('click', function () {
        let targetElement = $(this).data('scrollto');
        let target = $(`#${targetElement}`);
        if (target.length) {
            let targetOffset = target.offset().top - 100;
            $('html, body').animate({
                scrollTop: targetOffset
            }, 300);
        }
    });
});
